(() => {
	const debugMode = 1,
		testId = "GLX-014",
		logInfo = testId + " -->",
		variation = 1;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			// Wait for an element(s) to be fully loaded in the DOM
			const waitForElement = (cssSelector, callback, multi = false, maxCalls = 300) => {
				try {
					let elementsCached;

					const interval = setInterval(() => {
						try {
							if (multi) {
								elementsCached = document.querySelectorAll(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached.length) {
									clearInterval(interval);
									callback(elementsCached);
								}
							} else {
								elementsCached = document.querySelector(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached) {
									clearInterval(interval);
									callback(elementsCached);
								}
							}

							// After trying to find the element for 6 seconds, it stops
							if (typeof maxCalls === "number" && --maxCalls < 0) {
								clearInterval(interval);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}, 20);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const html = `
				<div class="${testId}-checkout-urgency">
					<div class="${testId}-urgency-row ${testId}-shipping-row">
						<svg class="${testId}-truck-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
							<path fill="none" stroke="white" stroke-width="1" d="M21 11.5l-1.5-3.4A1.5 1.5 0 0 0 18.13 7H16V5.5A1.5 1.5 0 0 0 14.5 4h-12A1.5 1.5 0 0 0 1 5.5v11A1.5 1.5 0 0 0 2.5 18H4a3 3 0 0 0 6 0h4a3 3 0 0 0 6 0h1.5a1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-.5-1zM7 19a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm10 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm4-3h-1.18a3 3 0 0 0-4.64 0h-6.36a3 3 0 0 0-4.64 0H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5V8h3.13a.5.5 0 0 1 .46.3L20 11.7v4.8a.5.5 0 0 1-.5.5h-.5z"/>
						</svg>
						<span>Ships in 2-5 business days</span>
					</div>
				</div>
			`;

			// Add cart progress
			const addUrgencyMessage = () => {
				try {
					const cartDrawer = document.querySelector("#cart-drawer");
					const cartItems = document.querySelector(".cart-drawer__items");

					if (cartDrawer) {
						if (!cartDrawer.querySelector(`.${testId}-checkout-urgency`)) {
							cartItems.insertAdjacentHTML("beforebegin", html);
						}
					}
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("body", (bodyElement) => {
				try {
					new MutationObserver(addUrgencyMessage).observe(bodyElement, {
						childList: true,
						subtree: true
					});

					addUrgencyMessage();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();